module.exports = __webpack_public_path__ + "img/15.8f731c5d.png";